export default {
    get_form_cb_outstanding_ref: state => { return state.form_cb_outstanding_ref },
    get_outstanding_amount: state => { return state.outstanding_amount },
    get_outstanding_pay: state => { return state.outstanding_pay },
    get_outstanding_ref: state => { return state.ref },
    get_outstanding_selected_currency: state => { return state.selected_currency }
};